import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateOrganizationNotifyList } from "~/providers/api/providers";
import { organizationNotifyListQueryOptionsFactory } from "~/providers/factories/organizationNotifyListQueryOptionsFactory";

export const useUpdateOrganizationNotifyList = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateOrganizationNotifyList,
    onSuccess: (_, { organizationId }) => {
      void queryClient.invalidateQueries({
        queryKey:
          organizationNotifyListQueryOptionsFactory.list(organizationId)
            .queryKey,
      });
    },
  });
};
